import api from './api';

export const menuService = {
  async getMenuItems(weddingId, organizationId, eventName = null) {
    let url = `/api/menu?wedding_id=${weddingId}&organization_id=${organizationId}`;
    if (eventName) {
      url += `&event_name=${eventName}`;
    }
    const response = await api.get(url);
    return response.data;
  },

  async createMenuItem(weddingId, organizationId, menuData) {
    const response = await api.post(`/api/menu?wedding_id=${weddingId}&organization_id=${organizationId}`, menuData);
    return response.data;
  },

  async updateMenuItem(itemId, menuData) {
    const response = await api.put(`/api/menu/${itemId}`, menuData);
    return response.data;
  },

  async deleteMenuItem(itemId) {
    const response = await api.delete(`/api/menu/${itemId}`);
    return response.data;
  },

  async setEventVendor(weddingId, eventName, vendorId) {
    const response = await api.post('/api/menu/event-vendor', null, {
      params: {
        wedding_id: weddingId,
        event_name: eventName,
        vendor_id: vendorId
      }
    });
    return response.data;
  },

  async getEventVendors(weddingId, organizationId) {
    const response = await api.get(`/api/menu/event-vendors?wedding_id=${weddingId}&organization_id=${organizationId}`);
    return response.data;
  }
};
